import { Attribute, booleanAttribute, ChangeDetectionStrategy, Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { provideParentFormGroup } from '../forms.utils';
import { FormBaseComponent } from '../form-base/form-base.component';

@Component({
  selector: 'app-form-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, TranslateModule],
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormInputComponent extends FormBaseComponent implements OnInit {
  @ContentChild('prefix') prefix: TemplateRef<any>;
  @ContentChild('suffix') suffix: TemplateRef<any>;
  @Input() hintText?: string;
  @Input({ transform: booleanAttribute }) fullWidth: boolean;

  ngOnInit(): void {}
}
